import { _ } from "core-js"

export default {
    isInCart: state => itemId => {
        return state.cartItems.some((item) => (item.objectID == itemId.objectID && item.student.id_usuario_estudiante == itemId.student.id_usuario_estudiante ))
    },
    isInWishList: state => itemId => {
        return state.wishList.some((item) => item.objectID == itemId )
    },
    obtenerClasificacion: state =>  {
        if(state.clasificacion_seleccionada == null)
            return JSON.parse(localStorage.getItem('clasificacion_seleccionada'));
        return state.clasificacion_seleccionada
    },
    cantidadProducto: state => producto => {
        const pro =  state.cartItems.find(i => i.objectID == producto.objectID && i.student.id_usuario_estudiante == producto.student.id_usuario_estudiante);
        if (pro == null)
            return 0;
        else 
            return pro.cantidad;
        
    },
}
